
export const FETCHING_OFFICES = 'FETCHING_OFFICES';
export const FETCH_OFFICES_SUCCESS = 'FETCH_OFFICES_SUCCESS';
export const FETCH_OFFICES_FAILED = 'FETCH_OFFICES_FAILED';

export const FETCHING_MEMBERS = 'FETCHING_MEMBERS';
export const FETCH_MEMBERS_SUCCESS = 'FETCH_MEMBERS_SUCCESS';
export const FETCH_MEMBERS_FAILED = 'FETCH_mEMBERS_FAILED';

export const fetchingOffices = () => {
    return {
        type: FETCHING_OFFICES
    }
};

export const fetchOfficesSuccess = offices => {
    return {
        type: FETCH_OFFICES_SUCCESS,
        payload: offices
    };
};

export const fetchOfficesFailed = err => {
    return {
        type: FETCH_OFFICES_FAILED,
        payload: err
    };
};

export const fetchingMembers = () => {
    return {
        type: FETCHING_MEMBERS
    }
};

export const fetchMembersSuccess = members => {
    return {
        type: FETCH_MEMBERS_SUCCESS,
        payload: members
    };
};

export const fetchMembersFailed = err => {
    return {
        type: FETCH_MEMBERS_FAILED,
        payload: err
    };
};